import React from "react";
import DualRangeSlider from "./Variants/DualRangeSlider";
import RatingSlider from "./Variants/RatingSlider";

const CustomSlider = ({
  title,
  ratingPoints,
  step = 1,
  unit,
  minValue,
  maxValue,
  showMinMaxFields,
  showLabeledRating,
  isRatingSlider = false,
  onChange,
  minValueName,
  maxValueName,
  filteredData,
  disabled,
}) => {
  return isRatingSlider ? (
    <RatingSlider
      title={title}
      ratingPoints={ratingPoints}
      showLabeledRating={showLabeledRating}
    />
  ) : (
    <DualRangeSlider
      title={title}
      unit={unit}
      step={step}
      showMinMaxFields={showMinMaxFields}
      minValueProp={minValue}
      maxValueProp={maxValue}
      onChange={onChange}
      minValueName={minValueName}
      maxValueName={maxValueName}
      filteredData={filteredData}
      disabled={disabled}
    />
  );
};

export default CustomSlider;
